import React from 'react';

import Icon from './Icon';
import Pill from './Pill';

const USPCard = (
  { icon, title, description, comingSoon = false, className },
  index
) => {
  return (
    <div key={index} className={className}>
      <Icon icon={icon} className="mb-4 text-cornflower" />

      {title && (
        <div className="flex items-baseline mb-4">
          <h5 className="font-semibold text-lg">{title}</h5>
          {comingSoon && <Pill label="Soon" size="small" className="ml-4" />}
        </div>
      )}

      {description && <p className="text-catskill-white">{description}</p>}
    </div>
  );
};

export default USPCard;
